<h2 mat-dialog-title class="timeline-item-dialog-title">
    <div>
        <i class="fa-sharp fa-light fa-stars pe-2"></i>
        {{'kudos.activity-modal.title' | translate}}
        <span class="position-absolute" style="right: 5%; color: #a0a0a0" (click)="onClose()"><i class="far fa-times"></i></span>
    </div>

</h2>

<mat-dialog-content class="dialog-content-pad-15" cdkOverlayOrigin #trigger="cdkOverlayOrigin">

    <div class="user-request-modal-body-text mb-3">
        <p class="mt-3" [innerHtml]="dialogInput.customKudos.descriptionLine1"></p>
        <p class="mt-3" [innerHtml]="dialogInput.customKudos.descriptionLine2"></p>
    </div>

</mat-dialog-content>

<mat-dialog-actions>
    <button type="button"
            data-cy="close-modal"
            class="btn btn-default"
            (click)="startKudos()">Create a Kudos on TeamMood</button>
    <a [href]="dialogInput.customKudos.ctaUrl" class="btn btn-primary">{{dialogInput.customKudos.ctaLabel}}</a>
</mat-dialog-actions>
